module.exports = __webpack_public_path__ + "static/media/serviceimg_02.7c2e2286.svg";